import { initializeApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { assertFirebaseConfig, firebaseConfig } from "./firebaseConfig";
import { connectAuthEmulator } from "firebase/auth";
import { connectFirestoreEmulator } from "firebase/firestore";
import { connectStorageEmulator } from "firebase/storage";

assertFirebaseConfig(firebaseConfig);

const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);

const useEmulators = String(process.env.REACT_APP_USE_FIREBASE_EMULATORS).toLowerCase() === "true";

export const auth = getAuth(app);
const firestoreDatabaseId = useEmulators ? null : process.env.REACT_APP_FIREBASE_DATABASE_ID;
export const db = firestoreDatabaseId ? getFirestore(app, firestoreDatabaseId) : getFirestore(app);
export const storage = getStorage(app);

if (useEmulators) {
  // CRA can hot-reload modules; guard repeated connections.
  const root =
    (typeof window !== "undefined" && window) ||
    (typeof global !== "undefined" && global) ||
    {};
  if (!root.__MYC_FIREBASE_EMULATORS_CONNECTED__) {
    root.__MYC_FIREBASE_EMULATORS_CONNECTED__ = true;
    connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
    connectFirestoreEmulator(db, "127.0.0.1", 8080);
    connectStorageEmulator(storage, "127.0.0.1", 9199);
  }
}
